// extracted by mini-css-extract-plugin
export default {"qr":"QR_qr__7JqmU","image":"QR_image__F5RQ5","pointer":"QR_pointer__696-V"};